import { createRouter, createWebHistory } from 'vue-router'
import PersonalSite from '../components/PersonalSite.vue'
import ArticlePage from '../components/ArticlePage.vue'
import TestPage from '../components/AppTest.vue'
import AiRadarPage from '../components/AiRadarPage.vue'
import AiPostsPage from '../components/AiPostsPage.vue'

const routes = [
  { path: '/', component: PersonalSite },
  { path: '/article', component: ArticlePage },
  { path: '/ai-radar', component: AiRadarPage },
  { path: '/ai-posts', component: AiPostsPage },
  { path: '/test', component: TestPage },
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

export default router
